var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShieldCheck({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_246_1385)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_246_1385)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6 20C6.55228 20 7 19.5523 7 19C7 18.4477 6.55228 18 6 18C5.44772 18 5 18.4477 5 19C5 19.5523 5.44772 20 6 20Z",
    fill: "#306BF5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 4C3.55228 4 4 3.55228 4 3C4 2.44772 3.55228 2 3 2C2.44772 2 2 2.44772 2 3C2 3.55228 2.44772 4 3 4Z",
    fill: "#306BF5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2 15C2.55228 15 3 14.5523 3 14C3 13.4477 2.55228 13 2 13C1.44772 13 1 13.4477 1 14C1 14.5523 1.44772 15 2 15Z",
    fill: "#306BF5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 20C18.5523 20 19 19.5523 19 19C19 18.4477 18.5523 18 18 18C17.4477 18 17 18.4477 17 19C17 19.5523 17.4477 20 18 20Z",
    fill: "#306BF5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5 11.9545L20.85 10.7182L18.675 5.46364C18.6 5.15455 18.3 5 18 5H15C14.55 5 14.25 5.30909 14.25 5.77273C14.25 6.23636 14.55 6.54545 15 6.54545H17.475L19.05 10.4091H17.625L17.85 9.94545C18 9.55909 17.85 9.09545 17.55 8.94091C17.175 8.78636 16.725 8.94091 16.575 9.25L16.05 10.4091H15C14.55 10.4091 14.25 10.7182 14.25 11.1818C14.25 11.6455 14.55 11.9545 15 11.9545H20.025L21.6 13.1909C22.2 13.6545 22.5 14.35 22.5 15.0455V17.3636C22.5 17.8273 22.2 18.1364 21.75 18.1364H20.175C19.875 16.8227 18.675 15.8182 17.25 15.8182C15.825 15.8182 14.7 16.8227 14.325 18.1364H9H8.925C8.625 16.8227 7.425 15.8182 6 15.8182C4.575 15.8182 3.45 16.8227 3.075 18.1364H3H0.75C0.3 18.1364 0 18.4455 0 18.9091C0 19.3727 0.3 19.6818 0.75 19.6818H3H3.075C3.375 20.9955 4.575 22 6 22C7.425 22 8.55 20.9955 8.925 19.6818H9H14.325C14.625 20.9955 15.825 22 17.25 22C18.675 22 19.8 20.9955 20.175 19.6818H21.75C23.025 19.6818 24 18.6773 24 17.3636V15.0455C24 13.8091 23.475 12.65 22.5 11.9545ZM6 20.4545C5.175 20.4545 4.5 19.7591 4.5 18.9091C4.5 18.0591 5.175 17.3636 6 17.3636C6.825 17.3636 7.5 18.0591 7.5 18.9091C7.5 19.7591 6.825 20.4545 6 20.4545ZM17.25 20.4545C16.425 20.4545 15.75 19.7591 15.75 18.9091C15.75 18.0591 16.425 17.3636 17.25 17.3636C18.075 17.3636 18.75 18.0591 18.75 18.9091C18.75 19.7591 18.075 20.4545 17.25 20.4545Z",
    fill: "#306BF5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.75 3.5H11.75C12.2 3.5 12.5 3.8 12.5 4.25V16.25C12.5 16.7 12.8 17 13.25 17C13.7 17 14 16.7 14 16.25V4.25C14 2.975 13.025 2 11.75 2H5.75C5.3 2 5 2.3 5 2.75C5 3.2 5.3 3.5 5.75 3.5Z",
    fill: "#306BF5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.72727 13C3.29091 13 3 13.4 3 14C3 14.6 3.29091 15 3.72727 15H10.2727C10.7091 15 11 14.6 11 14C11 13.4 10.7091 13 10.2727 13H3.72727Z",
    fill: "#306BF5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.77778 7H8.22222C8.68889 7 9 6.6 9 6C9 5.4 8.68889 5 8.22222 5H2.77778C2.31111 5 2 5.4 2 6C2 6.6 2.31111 7 2.77778 7Z",
    fill: "#306BF5"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_246_1385"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_246_1385"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShieldCheck);
export default __webpack_public_path__ + "static/media/shield-check.398593ea69506234a2057f8c6fef6497.svg";
export { ForwardRef as ReactComponent };